import { render, staticRenderFns } from "./FxIdModal.vue?vue&type=template&id=725fe887&"
import script from "./FxIdModal.vue?vue&type=script&lang=ts&"
export * from "./FxIdModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports